import RightArrow from "./img/arrow-tip-button.svg?react";
import "./style.scss";

export default function ArrowButton({ disabled, reverse, onClick, className="" }) {
  const btnClass = {
    base: "arrow-button",
    disabled: "disabled",
    reverse: "reverse",
  };
  return (
    <button
      onClick={onClick}
      className={`${btnClass.base} ${disabled ? btnClass.disabled : ""}
            ${reverse ? btnClass.reverse : ""} ${className}
            `}
    >
      <RightArrow />
    </button>
  );
}
